import axios from 'axios';
import { configRefs } from '@utils/constants';

async function activateRevisionRequest(user, revision) {
  if (!user || !user.institution?.id) {
    throw new Error("activateRevisionRequest(): missing user data");
  }
  if (!revision.__syncedWithBackend) {
    throw new Error("activateRevisionRequest(): revision is not present in the backend");
  }
  await axios.post(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/${encodeURIComponent(revision.id)}/Activate`, {
    userID: user.id,
    institutionID: user.institution.id
  });
  return;
}

export { activateRevisionRequest };
//# sourceMappingURL=request.activate.js.map
